












































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import BankExtractImportItems from "../components/BankExtractImportItems.vue";

import Vue from "vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import store, { BankExtractImportStore } from "../services/BankExtractImportStore";
import BankExtractImportItem from "../models/BankExtractImportItem";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import { t } from "@/plugins/i18n";

interface Data {
  store: BankExtractImportStore;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: { ApiSearchPage, IconButton, BankExtractImportItems, MoneyDisplay },

  data: () => ({
    store,
  }),

  methods: {
    create() {
      this.$router.push(`bank-extract-import/create`);
    },

    edit(item: BankExtractImportItem) {
      this.$router.push(`bank-extract-import/edit/${item.id}`);
    },
  },

  computed: {
    columns: (): ApiSearchColumn[] => [
      { cell: "detailsButton", filterable: false, sortable: false },
      { field: "id", title: t("Azonosito") },
      { field: "bankName", title: t("BankNeve") },
      { field: "bankAccountNo", title: t("Bankszamla") },
      { field: "invoiceNo", title: t("Szamlaszam") },
      {
        field: "status",
        title: t("Allapot"),
        type: ColumnType.Center,
        cell: "status",
      },
      { field: "fileName", title: t("FileNeve") },
      {
        field: "extractDate",
        title: t("KivonatDatuma"),
        type: ColumnType.Date,
      },
      {
        field: "importDate",
        title: t("BankExtract_BedolgozasDatuma_2"),
        type: ColumnType.Date,
      },
      {
        field: "openBal",
        title: t("NyitoEgyenleg_2"),
        type: ColumnType.Money,
        cell: "openBal"
      },
      {
        field: "closeBal",
        title: t("ZaroEgyenleg_2"),
        type: ColumnType.Money,
        cell: "closeBal"
      },
      { field: "currency", title: t("Penznem") },
      { cell: "command", filterable: false, sortable: false },
    ],
  },
});
